import { Text } from "recharts";

type TChartsCustomYAxisTick = ((props: any) => React.ReactElement<SVGElement>);

const ChartsCustomYAxisTick: TChartsCustomYAxisTick = (props) => {
  const { t, labelWidth, x, y, stroke, payload } = props;
  const color = stroke || "#666666";
  const fontSize = '8px';
  const text = !!t ? t(payload.value) : payload.value;
  const width = labelWidth ?? 80;
  const height = 24;
  return (
    <switch>
      {/* height="200" */}
      <foreignObject x={x - width + 4} y={y - height / 2} width={labelWidth ?? 80} height={height} textAnchor="middle" >
        <p style={{ color, fontSize, lineHeight: '1em', textAlign: 'center', width: `${labelWidth ?? 80}px`, wordBreak: text.toString().indexOf(' ') > -1 ? "break-word" : "break-all" }}>
          {text}
        </p>
      </foreignObject>
      <Text
        x={x} y={y + 2}
        style={{ fontSize }}
        fill={color}
        textAnchor="middle"
        width={labelWidth ?? 80}
        verticalAnchor="start"
      >
        {text}
        {/* This is a long tail text just to check if the text actually wraps to the next line or not */}
      </Text>
    </switch>
  )
}
export default ChartsCustomYAxisTick;